import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';
import NotificationsConfigList from 'notifications_config/components/list';
import { createRoute } from 'lib/util';

const { Form } = Common;

const NotificationsConfigListView = ({
  children,
  count = 0,
  filters = {},
  isLoading = false,
  company = {},
  pagination = {},
  permissions = {},
  subcompany = {},
  handleToggle = () => {}, ///////
  handleOrderChange = () => {},
  handleFiltersChange = () => {},
  handleLimitChange = () => {},
  handlePageChange = () => {},
  handleSubmit = () => {},
  columnSearch,
  handleToggleSearch = () => {}, // Agregar
  t,
}) => {
  return (
    <Common.Wrapper fluid={true}>
      {/* <NotificationsConfigList.Header
        companyId={company.id}
        subcompanyId={subcompany.id}
        canAdd={permissions["acl.notifications_config.add"]}
      /> */}
      <div className="col-12">
        <Common.Portlet
          title={t('menu.configuration') + ' > ' + t('notification_config.title')}
          icon={'archive'}
          button={
            <div className="btn-group pull-right">
              {permissions['acl.notifications_config.add'] && (
                <Form.Link
                  to={createRoute(company.id, subcompany.id, 'notifications_config/add')}
                  className="btn btn-info"
                >
                  {t('actions.add')}
                </Form.Link>
              )}
            </div>
          }
          buttonTwo={
            <NotificationsConfigList.Filters
              handleSubmit={handleSubmit}
              handleToggleSearch={handleToggleSearch} // Agregar
              columnSearch={columnSearch} // Agregar
              handleValueChange={handleFiltersChange}
              values={filters}
            />
          }
        >
          <div className="mb-2" style={{ position: 'relative' }}>
            <NotificationsConfigList.Table
              company={company} ////////
              subcompany={subcompany} ///////////
              permissions={permissions} ///////
              handleToggle={handleToggle} //////////
              count={count}
              handleOrderChange={handleOrderChange}
              order={pagination.order}
              orderBy={pagination.orderBy}
            >
              {children}
            </NotificationsConfigList.Table>
            <Common.LoaderOverlay show={isLoading} />
          </div>
          <Common.Pagination
            {...pagination}
            handleLimitChange={handleLimitChange}
            handlePageChange={handlePageChange}
          />
        </Common.Portlet>
      </div>
    </Common.Wrapper>
  );
};

export default translate()(NotificationsConfigListView);



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_config/components/NotificationsConfigListView.js